import { CalendarIcon } from '@grupoboticario/flora-react-icons';
import { ProgressCircle } from 'ui/components/compounds';
import { ButtonGhost, Icon } from 'ui/components/primitives';
import { mixins, styled, theme, utils } from 'ui/theme';

const ArrowCommon = styled.div`
  height: 24px;
  width: 24px;
  border: 1px solid ${theme.colors.action.navigation.standard.static};
  border-radius: 4px;
  opacity: 16%;
  align-self: center;
  &[data-active='true'] {
    opacity: 1;
    color: ${theme.colors.action.navigation.standard.static};
    border: 1px solid ${theme.colors.action.navigation.standard.static};
    cursor: pointer;
  }
`;

const Styles = {
  Component: styled('div')`
    ${mixins.baseFont}
    display: flex;
    gap: ${theme.space[2]};
    padding: ${theme.space[6]} ${theme.space[4]};

    ${utils.media.min('l')`
      padding: ${theme.space[4]} 0;
      justify-content: flex-end;
      &[data-empty-cycle='true'] {
        justify-content: center;
      }
    `}
  `,

  BrandName: styled.div`
    width: 67px;
    height: 24px;
    background: ${theme.colors.action.nonInteractive.emphasis};
    color: ${theme.colors.build.lightLight};
    border-radius: 4px;
    text-transform: capitalize;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-wrap: wrap;
    font-size: 12px;
    margin: -1px 8px 4px 0;
  `,

  CycleLength: styled('div')`
    padding-top: 2px;
  `,

  ArrowWrapper: styled('div')`
    display: flex;
  `,

  CycleDate: styled('small')`
    ${mixins.bodyMediumShort};
    color: ${theme.colors.build.darkLight};
    display: flex;
    > span {
      color: ${theme.colors.build.mediumLight1};
      margin-top: 2px;
      cursor: pointer;
    }
    svg {
      color: ${theme.colors.action.nonInteractive.emphasis};
    }
  `,

  CycleDaysLeft: styled('span')`
    ${mixins.bodyLargeStandard};
    color: ${theme.colors.build.darkLight};
    line-height: ${theme.sizes[5]};

    & span {
      font-weight: ${theme.fontWeights.strong};
      color: ${theme.colors.action.nonInteractive.emphasis};
    }
  `,

  CycleIcon: styled(CalendarIcon)`
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  `,

  CycleRectangleLoading: styled('small')`
    ${mixins.auxiliarMini};
    height: ${theme.sizes[4]};
    margin: ${theme.space[1]};
    width: ${theme.sizes[23]};
  `,

  Info: styled('div')`
    display: flex;
    flex-direction: column;
  `,

  Progress: styled(ProgressCircle)`
    width: ${theme.sizes[10]};
    & circle:nth-of-type(2) {
      stroke: ${theme.colors.action.nonInteractive.emphasis};
    }
  `,

  ProgressWrapper: styled('div')`
    color: ${theme.colors.action.nonInteractive.emphasis};
    align-items: center;
    display: flex;
    position: relative;
    &[data-is-multi-brand='true'] {
      margin-top: -9px;
    }
  `,
  ArrowBack: styled(ArrowCommon)`
    margin-right: 4px;
  `,
  ArrowForward: styled(ArrowCommon)`
    margin-left: 4px;
  `,
  EmptyCycle: styled('div')`
    display: flex;
    align-items: center;

    span {
      width: 180px;
      font-size: 14px;
    }
  `,
  ReloadCycleButton: styled(ButtonGhost)`
    margin-left: 12px;
    height: 32px;
    display: flex;
    align-items: center;
    width: 124px;
    justify-content: space-between;
    svg {
      height: 16px;
      margin-left: -4px;
      color: ${theme.colors.action.nonInteractive.emphasis};
    }
  `,
};

export default Styles;
